<template>
  <span v-if="type">
    <phone-return-icon v-if="type === 1"></phone-return-icon>
    <magnify-icon v-else-if="type === 2"></magnify-icon>
    <email-icon v-else-if="type === 3"></email-icon>
    <cake-variant-icon v-else-if="type === 4"></cake-variant-icon>
    <calendar-check-icon v-else></calendar-check-icon>
  </span>
</template>

<script>
export default {
  name: "TaskDescriptionIcon.vue",
  props: {
    type: Number,
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
